import { Box, Txt } from "@stenajs-webui/core";
import { FlatButton, stenaQuestionCircle } from "@stenajs-webui/elements";
import type { PropsWithChildren } from "react";

import { FreightPortalPopover } from "./popover/FreightPortalPopover";
import { PopoverBody } from "./popover/PopoverBody";
import { PopoverTitle } from "./popover/PopoverTitle";

interface HelpPopoverProps extends PropsWithChildren {
  descriptionText: string;
  headerText: string;
  tabIndex?: number;
}

export function HelpPopover({
  tabIndex,
  headerText,
  descriptionText,
  children,
}: HelpPopoverProps) {
  return (
    <FreightPortalPopover
      placement={"right"}
      renderTrigger={(triggerProps) => (
        <FlatButton
          {...triggerProps}
          tabIndex={tabIndex}
          leftIcon={stenaQuestionCircle}
          size={"small"}
        />
      )}
    >
      {({ onRequestClose }) => (
        <Box minWidth={240} maxWidth={360}>
          <PopoverTitle text={headerText} onClose={onRequestClose} />
          <PopoverBody gap={2}>
            <Txt>{descriptionText}</Txt>
            {children}
          </PopoverBody>
        </Box>
      )}
    </FreightPortalPopover>
  );
}
